module.exports = __webpack_public_path__ + "img/bd_coupon_adImg.d79beb46.jpg";